/*
 * Update an existing program line
 * - this follows a simple mutation pattern, where changed values will be patched, but we won't update the
 *   retrieved store.  This assumes that upon update, the edit experience exits, and programs are re-retreved.
 */
import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

  const abEnvironment = new AbEnvironment();
  const mutation = graphql`
  mutation VendorCommProgramLineUpdateMutation($input: UpdateCpLineTByCplIdInput!) {
    updateCpLineTByCplId(input: $input) {
      cpLineT {
        cplId
        revenuePeriod
        revenueMin
        incentivePerc
      }
    }
  }
  `;
    
  function commit(cplId, revenuePeriod, revenueMin, incentivePerc) {
    var variables = {
        input: {
            cplId,
            cpLineTPatch: {}
        }
    };

    if (revenuePeriod != null)
        variables.input.cpLineTPatch.revenuePeriod = revenuePeriod;
    if (revenueMin != null)
        variables.input.cpLineTPatch.revenueMin = revenueMin;
    if (incentivePerc != null)
        variables.input.cpLineTPatch.incentivePerc = incentivePerc;
    
    return new Promise((resolve, reject) => {
      commitMutation(
        abEnvironment.getEnvironment(), {
        mutation,
        variables,
        onCompleted: (response) => {
          resolve(response);
        },
        onError: (error) => {
          reject(error);
        }
      });
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
 